module.exports = __webpack_public_path__ + "images/img-1cKNwOi.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/managers/94.jpg
// module id = 2026
// module chunks = 0